import * as angular from "angular";
import {IController} from "angular";
import {LogisticsVehicle} from "../../models/logistics-vehicle.model";
import * as _ from "lodash"
import {VehicleOwnershipStatusType} from "../../types/vehicle-ownership-status.type";
import {Vehicle} from "../../../commons/models/vehicle.model";

export class CreateLogisticsVehicleFormCtrl implements IController {
  logisticsVehicle: LogisticsVehicle
  onChanges: Function;

  public sections: any;
  public siteDistanceUnit: string;
  public vehicleOwnershipStatusTypesList: VehicleOwnershipStatusType[];
  public today: string;
  public vehicleType: Vehicle;
  public vehicleMakes;

  constructor(private splitService, private moment, private VehiclesConstants) {
    this.siteDistanceUnit = splitService.getSiteDistanceLargeUnit(true);
    this.vehicleOwnershipStatusTypesList = Object.values(VehicleOwnershipStatusType);
  }

  $onInit() {
    this.vehicleMakes = this.VehiclesConstants.makes
    this.sections = {
      vehicleBasics: true,
      statusAndInfo: false,
      insurance: false,
      vehicleBackground: false
    }
    this.today = this.moment();
  }

  onVehicleTypeSelect(vehicle: Vehicle) {
    this.vehicleType = vehicle
    this._setVehicleWeights(vehicle);
    this.logisticsVehicle.vehicleTypeId = _.get(vehicle, 'id');
    this.onChanges({logisticVehicle: this.logisticsVehicle})
  }

  onBranchesSelect(branchIds) {
    this.logisticsVehicle.branchIds = branchIds;
  }

  kilometersChanged({value, path}) {
    _.set(this.logisticsVehicle, path, value);
    this.onChanges({logisticVehicle: this.logisticsVehicle})
  }

  onVehicleOwnershipStatus(ownershipType) {
    if (_.isUndefined(ownershipType)) {
      _.unset(this.logisticsVehicle, 'ownershipType');
    }
    this.onChanges({logisticVehicle: this.logisticsVehicle})
  }

  // onSellingDateChange
  onDateChange(selectedTimeStamp, path) {
    if (_.isUndefined(selectedTimeStamp)) {
      _.unset(this.logisticsVehicle, path);
    } else {
      const dateString = this.moment(selectedTimeStamp).format("YYYY-MM-DD");
      _.set(this.logisticsVehicle, path, dateString);
    }
    this.onChanges({logisticVehicle: this.logisticsVehicle})
  }

  private _setVehicleWeights(vehicleType) {
    _.set(this.logisticsVehicle, 'weight', vehicleType?.weight)
    _.set(this.logisticsVehicle, 'allowedWeight', vehicleType?.allowedWeight)
    _.set(this.logisticsVehicle, 'vehicleCapacity.weight', vehicleType?.vehicleCapacity?.weight)
  }
}

angular
  .module('bringoz.admin.logistics-vehicle')
  .component('createLogisticsVehicleForm', {
    require: {
      form: '^form'
    },
    bindings: {
      logisticsVehicle: '<',
      onChanges: '&',
    },
    template: require('./create-logistics-vehicle-form.html').default,
    controller: CreateLogisticsVehicleFormCtrl
  });
